// @vue/component
export default {
  name: 'ReportsFormExportItemText',

  props: {
    currentField: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      fieldValue: this.currentField.default_value,
    };
  },
};
